<template>
	<div class="donut-legend">
		<ja-donut-chart
			:chart-value="value"
			:label-chart-a="labelChartA"
			:label-chart-b="labelChartB"
		></ja-donut-chart>
		<div class="bar-label" aria-hidden="true">
			<div class="body-text-2 donut-legend__title">
				{{ title }}
			</div>
			<div class="chart-legend" aria-hidden="true">
				<div
					class="chart-legend__color"
					:style="{ backgroundColor: chartColorA }"
				></div>
				<span class="chart-legend__label body-text-3">{{ chartLegendA }}</span>
			</div>
			<div class="chart-legend" aria-hidden="true">
				<div
					class="chart-legend__color"
					:style="{ backgroundColor: chartColorB }"
				></div>
				<span class="chart-legend__label body-text-3">{{ chartLegendB }}</span>
			</div>
		</div>
	</div>
</template>
<script>
import DonutChart from '../Chart/DonutChart.vue';
export default {
	components: {
		jaDonutChart: DonutChart
	},
	props: {
		value: {
			type: Number,
			required: true
		},
		labelChartA: {
			type: Number,
			default: 0,
			required: false
		},
		labelChartB: {
			type: Number,
			default: 0,
			required: false
		},
		size: {
			type: Number,
			default: 60
		},
		title: {
			type: String,
			default: ''
		},
		status: {
			type: String,
			default: ''
		},
		chartLegendA: {
			type: String,
			default: ''
		},
		chartLegendB: {
			type: String,
			default: ''
		},
		chartColorA: {
			type: String,
			default: '#00a0af'
		},
		chartColorB: {
			type: String,
			default: '#285f74'
		}
	}
};
</script>
<style lang="scss" scoped>
.donut-legend {
	display: flex;
	flex-direction: column;
	align-items: center;
	&__title {
		font-size: 20px;
		margin-top: 8px;
		width: 240px;
		text-align: center;
		height: 50px;
	}
}
.chart-legend {
	display: flex;
	align-items: center;
	margin-top: 8px;
	padding-left: 40px;
	&__color {
		height: 10px;
		width: 10px;
		margin-right: 16px;
	}
	&__label {
		text-align: center;
		font-size: 15px;
	}
}
</style>
